<template>
    <div class="auth-welcome-container">
        <p class="title">Welcome to Hedlyner</p>
        <div class="email-input-wrapper">
            <label for="email-input">Email *</label>
            <input
                v-model="$v.formValues.email.$model"
                v-autofocus
                @keydown="$v.formValues.email.$touch"
                @keyup.enter="handleInitializeAuth($v)"
                class="email-input"
                name="email-input"
                type="email"
                placeholder="Enter your email to get started..."
            />
            <p
                v-if="$v.formValues.email.$dirty && !$v.formValues.email.required"
                class="error-msg"
            >
                Please enter your email address.
            </p>
            <p
                v-else-if="$v.formValues.email.$dirty && !$v.formValues.email.email"
                class="error-msg"
            >
                Please enter a valid email address.
            </p>
        </div>
        <button @click="handleInitializeAuth($v)" class="continue-btn">Continue</button>
        <AuthSocial role="user" />
    </div>
</template>
<script>
    import { required, email } from 'vuelidate/lib/validators'
    import { useWelcomeStep } from '@/composables/auth/useWelcomeStep'
    import AuthSocial from '@/components/auth/parts/AuthSocial.vue'

    export default {
        name: 'AuthWelcome',
        components: {
            AuthSocial
        },
        setup() {
            const {
                formValues,

                handleInitializeAuth
            } = useWelcomeStep()

            return {
                formValues,

                handleInitializeAuth
            }
        },
        validations: {
            formValues: {
                email: { required, email }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .auth-welcome-container {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        width: 100%;
        gap: 40px;

        .title {
            color: #dedede;
            font-family: Instrument Sans;
            font-size: 38px;
            font-style: normal;
            font-weight: 500;
            line-height: 110%;
            letter-spacing: -0.76px;
        }
        .email-input-wrapper {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            width: 100%;
            gap: 6px;

            label {
                color: #acacac;
                font-family: Instrument Sans;
                font-size: 12px;
                font-style: normal;
                font-weight: 650;
                line-height: 135%;
                letter-spacing: 0.12px;
            }
            .email-input {
                padding: 12px 16px 16px 16px;
                border-radius: 12px;
                border: 1px solid #8b8b8b;
                background: #262626;
                overflow: hidden;
                color: #dedede;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-family: Instrument Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 550;
                line-height: 125%;
                align-self: stretch;
            }
            .error-msg {
                color: #ed3c0d;
                font-family: Instrument Sans;
                font-size: 10px;
                font-style: normal;
                font-weight: 600;
                line-height: 130%;
                letter-spacing: 0.14px;
            }
        }
        .continue-btn {
            padding: 11px 30px 12px 30px;
            border-radius: 100px;
            background: #cdeb09;
            align-self: stretch;
            color: #121212;
            font-family: Instrument Sans;
            font-size: 18px;
            font-style: normal;
            font-weight: 550;
            line-height: 120%;
        }
    }
</style>
